import { Button, message } from "antd";
import React, { useEffect, useState } from "react";

const MessageA15 = (props) => {
    const { inputValue ,item  ,showMaximumChat} = props;
    const [onSelect, setOnSelect] = useState(false);
    const [disableButton, setDisableButton] = useState(false);

    useEffect(() => {
        props.setisSubscriber(false);
    }, []);

    useEffect(()=>{

        const validValues = Object.values(props?.errors).filter(value => value);
        const inputValue = validValues.map(item => item?.inputError)
        
        // Check for input errors first
        if(inputValue[0] === "Special characters" || inputValue[0] === "Input cannot be empty"){
            setDisableButton(true)
            return;
        }

        // Check infoText for pack selection buttons
        const infoText = props?.item?.infoText;
        if (infoText === 'add' || infoText === 'drop' || infoText === 'both' || infoText === 'all') {
            const allAddPacks = validValues.flatMap(v => v?.addPackList || []);
            const allDropPacks = validValues.flatMap(v => v?.dropPackList || []);
            const allChannelNames = validValues.flatMap(v => v?.key1?.channelName || []);
            const allPackNames = validValues.flatMap(v => v?.key1?.packName || []);
            const hasBoth = allAddPacks.length > 0 && allDropPacks.length > 0;
            
            if (infoText === 'add') {
                // Enable only if there are add packs BUT NOT both
                setDisableButton(allAddPacks.length === 0 || hasBoth);
            } else if (infoText === 'drop') {
                // Enable only if there are drop packs BUT NOT both
                setDisableButton(allDropPacks.length === 0 || hasBoth);
            } else if (infoText === 'both') {
                // Enable only if there are BOTH add AND drop packs
                setDisableButton(!hasBoth);
            } else if (infoText === 'all') {
                // Enable if there are any data (channelName, packName, addPackList, or dropPackList)
                setDisableButton(allChannelNames.length === 0 && allPackNames.length === 0 && allAddPacks.length === 0 && allDropPacks.length === 0);
            }
        } else {
            setDisableButton(false);
        }
    },[props?.errors, props?.item?.infoText])

    if (!props?.item?.text?.trim()) {
        return null;
      }
    

    const handleClick = () => {
        if (props.disable || disableButton) return;

        let input;
        const data = JSON.parse(localStorage.getItem("inputValue"));
        const data1 = JSON.parse(localStorage.getItem("inputValue1"));
        const boxData = JSON.parse(localStorage.getItem("inputBoxValue"));
        const troubleShooting = JSON.parse(localStorage.getItem("troubleShooting"));

        const errorEntries = Object.entries(props?.errors).filter(
            ([_, value]) =>
              value === false ||
              (typeof value === "object" &&
               value !== null &&
               !value.key1 &&
               typeof value.inputError === "string" &&
               value.inputError.trim() !== "")
          );
          
        const hasErrors = errorEntries.length > 0;

        errorEntries.forEach(([errorKey, _]) => {
            let elementsList = document.querySelectorAll(`[class*='${errorKey}']`);

            elementsList.forEach(element => {
                element.classList.add("error-active"); // Add blinking effect
            });
        });

        // Remove error class when fixed
        Object.entries(props?.errors).forEach(([errorKey, value]) => {
            if (value !== false) {
                let elementsList = document.querySelectorAll(`[class*='${errorKey}']`);
                elementsList.forEach(element => element.classList.remove("error-active"));
            }
        });

        if (hasErrors ) {
            let errorMessage = "Please fill in all required fields!"; // Default for multiple errors

            if (errorEntries?.length === 1) {  // Check only false values, not all errors
                const [errorKey] = errorEntries[0]; // Get the first false key
                const errorType = errorKey.split("-")[0]; // Extract uiCommand (e.g., "A13")

                switch (errorType) {
                    case "A13":
                        errorMessage = "Please select a dropdown option.";
                        break;
                    case "A14c":
                        errorMessage = "Please enter a value in the input box.";
                        break;
                    case "A13s":
                        errorMessage = "Please select the setup box and proceed";
                        break;
                    case "A14s":
                        errorMessage = "Please Enter Description/Pack.";
                        break;
                    case "A13ts":
                        errorMessage = "Please select the Box.";
                        break;
                    case "A3":
                        errorMessage = "Please select.";
                        break;
                    case "A22":
                        errorMessage = "Please select Date and Time";
                        break;
                    case "A14info":
                    case "A14input":
                        const validValues = Object.values(props?.errors).filter(value => value);
                        const inputValue = validValues.map(item => item?.inputError)
                        if(inputValue[0] === "email"){
                            errorMessage = "Please give valid email" 
                        }else{
                          errorMessage = "Please give input";
                        }
                        
                        break;
                    case "A3table":
                        errorMessage = "Please select ID";
                        break;
                    case "A13ExplorePacks":
                        errorMessage = "Please select Pack";
                        break;
                    case "A13rechargeOptions":
                        errorMessage = "Please Select Option";
                        break;
                    default:
                        errorMessage = "Invalid input. Please check your fields.";
                }
            }

            message.config({
                getContainer: () => document.querySelector(".bot-chat-wrap"),
                duration: 2,
            });

            console.log(errorMessage);
            message.error(errorMessage);
            return;
        }

        // if (data1 && data && props?.item?.text === "Confirm") { //handled only for intent flow

        //     localStorage.removeItem("inputValue1");
        //     localStorage.removeItem("inputValue");
        //     input = `${data1?.key1} ${data?.key1 && `: ${data?.key1}`}`;

        //     props?.addMessages(input, props?.item?.code, props?.item?.text);
        //     setOnSelect(true);
        // } else {

            const validValues = Object.values(props?.errors).filter(value => value);
            const infoText = props?.item?.infoText;

            if (validValues.length === 1) {
                // Single value: Store as object
                const input = validValues[0]?.key1;
                const displayText = validValues[0]?.displayName;

                props?.addMessages(input, props?.item?.code, props?.item?.text, displayText);
            } else if (validValues.length > 1) {
                if (infoText === 'add' || infoText === 'drop' || infoText === 'both' || infoText === 'all') {

                    const mergedData = validValues.reduce(
                        (acc, item) => {
                            const key1 = item?.key1 || {};

                            if (key1.addPackList) {
                                acc.addPackList.push(...key1.addPackList);
                            }

                            if (key1.dropPackList) {
                                acc.dropPackList.push(...key1.dropPackList);
                            }

                            // ONLY for "all" → merge channel & pack names
                            if (infoText === 'all') {
                                if (key1.packName) {
                                    acc.packName.push(...key1.packName);
                                }
                                if (key1.channelName) {
                                    acc.channelName.push(...key1.channelName);
                                }
                            }

                            return acc;
                        },
                        {
                            addPackList: [],
                            dropPackList: [],
                            packName: [],
                            channelName: []
                        }
                    );

                    // Optional but recommended: de-duplicate
                    mergedData.addPackList = [...new Set(mergedData.addPackList)];
                    mergedData.dropPackList = [...new Set(mergedData.dropPackList)];
                    mergedData.packName = [...new Set(mergedData.packName)];
                    mergedData.channelName = [...new Set(mergedData.channelName)];

                    const displayText = validValues
                        .map(item => item.displayName)
                        .join(', ');

                    props?.addMessages(mergedData,props?.item?.code,props?.item?.text,displayText
                    );

                } else {
                    // Non pack-selection case
                    const input = JSON.stringify(validValues.map(item => item.key1));
                    const displayText = validValues.map(item => item.displayName).join(', ');

                    props?.addMessages(input, props?.item?.code, props?.item?.text, displayText);
                }
            }


            setOnSelect(true);
            
            // Mark message as processed
            if (props.messageId && props.setProcessedMessages) {
                props.setProcessedMessages(prev => new Set([...prev, props.messageId]));
            }

        // }


        // if (data && (props?.item?.text === "Submit" || props?.item?.text === "Pack Details" )) {
        //     localStorage.removeItem("inputValue");
        //     // Extract valid values from errors
        //     const validValues = Object.values(props?.errors).filter(value => value);
        //     // Determine whether to store as an array or a string
        //     const input =  validValues.length > 1 ? JSON.stringify(validValues): validValues[0]?.key1 ;

        //     const displayText = input?.displayName || validValues.length > 1 ? validValues.join(' , ') : validValues[0];

        //     props?.addMessages(input, props?.item?.code, props?.item?.text, input, displayText);
        //     setOnSelect(true);

        // } else if (troubleShooting && props?.item?.text === "Yes" || props?.item?.text === "No") {
        //     localStorage.removeItem("troubleShooting");
        //     input = troubleShooting?.key1;

        //     props?.addMessages(input, props?.item?.code, props?.item?.text, input, props?.item?.text);
        //     setOnSelect(true);

        // } else if (boxData && props?.item?.text === "Confirm" || props?.item?.text === "Skip To Work Order Creation") {
        //     localStorage.removeItem("inputBoxValue");
        //     const validValues = Object.values(props?.errors).filter(value => value);
        //     // Determine whether to store as an array or a string
        //     const input =  validValues.length > 1 ? JSON.stringify(validValues): validValues[0] ;
        //     const displayText = data?.displayName || validValues.length > 1 ? validValues.join(' , ') : validValues[0];

        //     props?.addMessages(input, props?.item?.code, props?.item?.text, input, displayText);
        //     setOnSelect(true);

        // } else if (data1 && data && props?.item?.text === "Confirm") {
        //     localStorage.removeItem("inputValue1");
        //     localStorage.removeItem("inputValue");
        //     input = `${data1?.key1} ${data?.key1 && `: ${data?.key1}`}`;

        //     props?.addMessages(input, props?.item?.code, props?.item?.text, input);
        //     setOnSelect(true);

        // } else {
        //     input = props?.item?.text;
        //     props?.addMessages(null, props?.item?.code, props?.item?.text);
        //     setOnSelect(true);
        // }
        localStorage.removeItem("inputValue");
        localStorage.removeItem("troubleShooting");
        localStorage.removeItem("inputBoxValue");
        localStorage.removeItem("inputValue1");
        localStorage.removeItem("ignoreError");
    };

    return (
        <div
            className="a1-wrap"
            style={{ width: "fit-content", margin: "6px", cursor: "pointer" }}
        > {
            props?.item?.text && 
         <div
            className={`${!onSelect ? "chat-label" : "chat-label-select"} action-tab`}
            id="main-tab1"
            style={{
                cursor: disableButton ? "not-allowed" : "pointer",
                opacity: disableButton ? 0.5 : 1,
                pointerEvents: disableButton ? "none" : "auto",
                backgroundColor: disableButton ? "#d3d3d3" : "",
            }}
                onClick={handleClick}
                disable={disableButton}
                >
                    {(() => {
                    try {
                    const parsed = JSON.parse(props?.item?.data || "{}");
                    if (parsed?.button === "new" && parsed?.img) {
                        return (
                            <img
                            src={parsed?.img}
                            alt={props?.item?.text}
                            style={{
                              width: "28px",
                              height: "24px",
                              marginRight : '4px',

                            //   mixBlendMode: "darken", // blends white with background
                            }}
                          />
                          
                        );
                    }
                    } catch {
                    return null;
                    }
                    return null;
                })()}
                {props?.item?.text}
                {/* NEW Tag */}
                {(() => {
                    try {
                        const parsed = JSON.parse(props?.item?.data || "{}");
                        if (parsed?.button === "new") {
                        return (
                            <div
                            style={{
                                background: "red",
                                color: "white",
                                fontSize: "10px",
                                fontWeight: "bold",
                                padding: "2px 6px",
                                borderRadius: "10px",
                                whiteSpace: "nowrap",
                                marginLeft : '10px'
                            }}
                            >
                            NEW
                            </div>
                        );
                        }
                        return null;
                    } catch {
                        return null;
                    }
                })()}

            </div> }



        </div>
    );
};

export default MessageA15;
